document.addEventListener('DOMContentLoaded', function () {
  /* BD perf: sticky-atc only exists on product pages, but this file loads
     site-wide and used to run a document-wide MutationObserver forever on
     every page. Now: product template only, observer stops as soon as the
     element is handled, hard stop after 15s. */
  if (document.documentElement.getAttribute('data-template') !== 'product') return;

  var done = false;
  var observer = null;

  function reveal() {
    if (done) return false;
    var stickyATC = document.querySelector('sticky-atc.form.product-form.flex');
    if (!stickyATC) return false;
    stickyATC.style.display = 'flex';
    done = true;
    if (observer) observer.disconnect();
    return true;
  }

  // fallback delay (same 1.5s behaviour as before)
  setTimeout(reveal, 1500);

  // live watcher
  if (!reveal()) {
    observer = new MutationObserver(function () { reveal(); });
    observer.observe(document.body, { childList: true, subtree: true });
    // safety: never leave the observer running indefinitely
    setTimeout(function () { if (observer) observer.disconnect(); }, 15000);
  }
});
